export default __webpack_public_path__ + "static/media/logo.d9bc4886.PNG";